<template>
  <div>
    <Header>
    </Header>

    <div class="page">

        <div class="block">
            <h3 class="block__heading" v-t="'Contact Form Messages'"></h3>
            <p v-t="'people.contactform-desc'"></p>
        </div>

        <table class="editor-table">
            <thead>
                <tr>
                    <th width="25%" v-t="'From'"></th>
                    <th width="150px" v-t="'Date'"></th>
                    <th v-t="'Message'"></th>
                </tr>
            </thead>
            <tbody v-if="!contactforms">
                <tr>
                    <td colspan="100%">
                        <div class="loading-gif" >
                            <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                        </div>
                    </td>
                </tr>
            </tbody>
            <tbody v-if="contactforms">
                <tr v-bind:key="message.id" v-for="message in contactforms" @click="goToMessage(message)" style="cursor: pointer;">
                    <td>
                        <h3>{{message.name}}</h3>
                        <span class="ellipsis grey">
                        {{message.email}}</span>
                    </td>
                    <td>
                        {{message.created | date }}
                    </td>
                    <td>
                        {{message.message}}
                    </td>
                </tr>
                <tr v-if="contactforms.length==0">
                    <td colspan="100%" v-t="'No Messages yet.'">

                    </td>
                </tr>
            </tbody>
            <tfoot v-if="contactforms">
                <td colspan="100%">
                    {{contactforms.length}} <span v-t="'Messages'"></span>
                </td>
            </tfoot>
        </table>
    </div>

</div>
</template>

<script>
    import Header from '@/components/Header.vue'

    export default {
      components: {
        Header,
    },
    data () {
        return {
            VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
            contactforms: null
        }
    },
    methods: {
      goToMessage (message) {
        this.$router.push({ name: 'contactform', params: { id: message.id } })
      }
    },
    mounted () {
        this.$http.get('/contact-forms/').then(data => {
            this.contactforms = data.data
        })
    }
}
</script>
